import React from "react";
import {connect} from "react-redux";
import {IPX_PID, STORAGE_KEY} from "../../utils/constants";
import {updateAvatarInfo} from "store/actions/avatar";
import _ from "lodash";
import Login from "components/Login";
import * as action from "../../store/actions/userInfo";
import * as TrackingUtil from "../../utils/TrackingUtil";
import {getUser, getUserAvatarList, getAvatarList, createUserAvatar} from "api-v3";
import uuid4 from "uuid4";

class UserInfoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.queryParams = new URLSearchParams(window.location.search);
    this.playMode = this.queryParams.get("mode");
    this.isGuestMode = this.queryParams.get("isGuest");
    this.device = navigator.userAgent.toLowerCase();
    this.state = {mounted: this.queryParams.get("pid") ? false : true};
    this.token = localStorage.getItem(STORAGE_KEY.REDBRICK_TOKEN) || this.queryParams.get("token");

    this.addMessageListener(this.device);
    this.setTokenForLogin();

    // COMMENT : GUEST MODE FEATURE

    // this.isGuestMode = localStorage.getItem("isGuestMode");

    // window.addEventListener("message", event => {
    //   switch (event.data.type) {
    //     case "user":
    //       if (event.data.mode === "guest" && !this.isGuestMode && !this.token) {
    //         console.log("SET GUEST MODE");
    //         localStorage.setItem("isGuestMode", true);
    //         window.location.reload();
    //       }
    //       break;
    //     default:
    //       break;
    //   }
    // });
  }

  componentDidMount = async () => {
    let avatarInfo;
    const pid = this.queryParams.get("pid");

    this.fromIpx = _.includes(IPX_PID, pid);
    if (this.token) {
      // localStorage.removeItem("isGuestMode");
      avatarInfo = await this.handleAvatarInfo();
      this.handleLoginByToken(avatarInfo);
    }
    if (this.fromIpx) {
      this.props.updateAvatarInfo({});
    }
    if (this.isGuestMode && this.playMode === "play") {
      this.handleGuestMode();
    }
    this.setState({mounted: true});
  };

  setTokenForLogin = () => {
    if (this.token) {
      localStorage.setItem(STORAGE_KEY.REDBRICK_TOKEN, this.token);
    }
  };

  handleLoginByToken = async avatarInfo => {
    if (this.token) {
      try {
        const res = await getUser();
        if (!res.data) {
          throw new Error("User does not exist");
        }
        let user = {
          ...res.data,
          avatarInfo: avatarInfo.data,
        };
        this.props.updateUserInfo(user);
        TrackingUtil.sendAPEvent({
          event: "setUserId",
          "DLV - userid": user.email,
        });
        this.setState({mounted: true});
      } catch (err) {
        this.props.logout();
        this.setState({mounted: true});
      }
    } else {
      this.props.logout();
      this.setState({mounted: true});
    }
  };

  addMessageListener(device) {
    if (device.indexOf("android") > -1) {
      document.addEventListener("message", event => {
        const {type, value} = JSON.parse(event.data);

        switch (type) {
          case "token":
            localStorage.setItem(STORAGE_KEY.REDBRICK_TOKEN, value);
            window.location.reload();
            break;
          default:
            break;
        }
      });
    } else if (device.indexOf("iphone") > -1 || device.indexOf("ipad") > -1 || device.indexOf("ipod") > -1) {
      window.addEventListener("message", event => {
        const {type, value} = JSON.parse(event.data);

        switch (type) {
          case "token":
            localStorage.setItem(STORAGE_KEY.REDBRICK_TOKEN, value);
            window.location.reload();
            break;
          default:
            break;
        }
      });
    }
  }

  handleGuestMode = () => {
    const uuid = uuid4();
    const name = `GUEST-${uuid.slice(0, 4)}`;
    try {
      let guest = {
        name: name,
        avatarInfo: {},
      };
      this.props.updateUserInfo(guest);
      this.setState({mounted: true});
    } catch (err) {
      this.props.logout();
      this.setState({mounted: true});
    }
  };

  handleAvatarInfo = async () => {
    if (this.token) {
      try {
        let response = await getUserAvatarList({isPrimary: true});
        if (response.data.items.length === 0) {
          response = await getAvatarList({category: "IPX"});

          const createdAvatar = await createUserAvatar(response.data.items[0]);
          response.data.items[0].id = createdAvatar.data.id;
        }
        const params = {
          data: [
            {
              id: response.data.items[0].id,
              avatarId: response.data.items[0].avatarId,
              category: response.data.items[0].category,
              preview: response.data.items[0].preview,
              description: response.data.items[0].description,
              url: response.data.items[0].url,
              name: response.data.items[0].name,
            },
          ],
        };
        this.props.updateAvatarInfo(params.data[0]);

        return params;
      } catch (e) {
        console.log("Failed to get avatar data");
      }
    }
  };

  render() {
    if (this.state.mounted === false) {
      return null;
    }

    if (this.token) {
      return this.props.children;
    }

    // Note: Uncomment if you want to skip login
    // if (this.fromIpx) {
    //   return this.props.children;
    // }

    if (this.isGuestMode && this.playMode === "play") {
      return this.props.children;
    }

    return <Login />;
  }
}

export default connect(
  state => ({
    userinfo: state.userinfo,
  }),
  {
    logout: action.logout,
    updateUserInfo: action.updateUserInfo,
    updateAvatarInfo: updateAvatarInfo,
  },
)(UserInfoContainer);
